module.exports = __webpack_public_path__ + "img/horizontal_3_3_r_8004.419a2d89.png";